import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { NbTokenService } from '@nebular/auth';

@Injectable()
export class AuthGuardService implements CanActivate {

  constructor(
    private authService: AuthService,
    private tokenService: NbTokenService,
    private router: Router
  ) { }

  canActivate(route: ActivatedRouteSnapshot) {
    let result: boolean;
    if (this.authService.isAuthenticated()) {
      const groups = route.data?.groups as Array<string>;
      if (!groups || groups.length === 0 || (groups && this.authService.isAuthorized(groups))) {
        result = true;
      } else {
        result = false;
      }
    } else {
      result = false;
    }
    return of(result)
      .pipe(
        tap(authenticated => {
          if (!authenticated) {
            this.tokenService.clear();
            this.router.navigate(['auth/login']);
          }
        }),
      );
  }
}